var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.displayNextPage || _vm.displayPreviousPage
      ? _c(
          "nav",
          {
            attrs: {
              role: "navigation",
              "aria-label": _vm.$t("pagination.navigation_label"),
            },
          },
          [
            _c(
              "div",
              {
                key: _vm.resetPagination,
                staticClass:
                  "d-flex p-0 align-items-center justify-content-center",
              },
              [
                _vm.displayPreviousPage
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "p-2 pagination-button cursor btn btn-link",
                        attrs: {
                          "aria-label": _vm.$t("pagination.previous_page"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.pagination(_vm.currentPage - 1)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa-solid fa-chevron-left" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.displayNextPage
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "p-2 pagination-button cursor btn btn-link",
                        attrs: { "aria-label": _vm.$t("pagination.next_page") },
                        on: {
                          click: function ($event) {
                            return _vm.pagination(_vm.currentPage + 1)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa-solid fa-chevron-right" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "resultsTextPagination ml-3 mb-0" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("common.results_desc") +
                        " " +
                        _vm.firstIndex +
                        " " +
                        _vm.$t("common.to") +
                        " " +
                        _vm.lastResultIndex
                    )
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }